"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FetchError extends Error {
    constructor(url, options = {}, message) {
        super(`Fail to fetch resource "${(options.method || 'get').toLowerCase()} ${url}": ${message}`);
        this.code = 'FETCH_ERROR';
        this.options = {};
        this.url = url;
        this.options = options;
    }
}
exports.default = FetchError;
